import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Easter egg for curious developers
console.log(
  '%c👁  ClearWay',
  'font-size: 22px; font-weight: 700; color: #3b82f6; font-family: system-ui, sans-serif;'
);
console.log(
  '%cBuilt to help people navigate the world safely.\nCurious about what we\'re making? Say hi → hello@clearway.tech',
  'color: #9ca3af; font-size: 13px; line-height: 1.6;'
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register();
